import { ChangeEvent, useEffect, useRef, useState } from 'react';
import Input, { InputProps } from '.';
import SVG from '../SVG';

interface InputPasswordProps extends InputProps {}

const InputPassword = ({ ...rest }: InputPasswordProps) => {
  const [showPassword, setShowPassword] = useState(false);
  const EyeIcon = SVG.Icon.PasswordEye[showPassword ? 'Open' : 'Close'];
  return (
    <Input
      type={showPassword ? 'text' : 'password'}
      IconRight={
        <label
          style={{
            cursor: 'pointer',
            display: 'flex',
            userSelect: 'none',
          }}
        >
          {/* <EyeIcon
            style={{
              cursor: "pointer",
              margin: "auto 1rem auto 0",
              zIndex: "2",
            }}
            fill="#212121"
            onMouseDown={() => {
              setShowPassword(!showPassword);
            }}
          /> */}
        </label>
      }
      {...rest}
    />
  );
};

export default InputPassword;
